import helper from 'store/helper';
import { PRIORITY_AXIS_MEDIA_SYNC } from 'domain/consts';
import { PERIOD_TYPE } from 'domain/period-analyze/consts';
import dedupeDimensions from 'domain/adebify/dedupeDimensions';
import { PRODUCT_ANALYSIS_DEFAULT_METRICS } from 'views/pages/adebify/product-analysis/components/metricsCatalog';
import types from './types';

export const initialState = {
  data: null,
  graphData: null,
  meta: null,
  isLoading: false,
  error: null,
  params: {
    product_axis: 'purchased_product',
    axis: PRIORITY_AXIS_MEDIA_SYNC,
    dimensions: ['product_category', 'purchased_product'],
    metrics: PRODUCT_ANALYSIS_DEFAULT_METRICS,
    period_type: PERIOD_TYPE.DAY,
    graph_metric: 'total_revenue',
    sort_by: null,
    sort_order: 'DESC',
    limit: 200,
    offset: 0,
  },
};

const fetchData = (state) => ({
  ...state,
  isLoading: true,
  error: null,
});

const fetchSuccess = (state, action) => {
  const { data, graphData, meta } = action.payload;
  return {
    ...state,
    data,
    graphData,
    meta,
    isLoading: false,
    error: null,
  };
};

const fetchError = (state, action) => {
  const { error } = action.payload;
  return {
    ...state,
    isLoading: false,
    error,
  };
};

const setParams = (state, action) => {
  const nextParams = { ...state.params, ...action.payload };
  if (Array.isArray(nextParams.dimensions)) {
    nextParams.dimensions = dedupeDimensions(nextParams.dimensions);
  }
  return {
    ...state,
    params: nextParams,
  };
};

// Clear fetched report data only; keep params (display-item selections)
// so they survive navigation like settings.displayItems on legacy screens.
const cleanState = (state) => ({
  ...state,
  data: null,
  graphData: null,
  meta: null,
  isLoading: false,
  error: null,
});

const AdebifyProductAnalysisReducer = helper.createReducer(initialState, {
  [types.FETCH_DATA]: fetchData,
  [types.FETCH_SUCCESS]: fetchSuccess,
  [types.FETCH_ERROR]: fetchError,
  [types.SET_PARAMS]: setParams,
  [types.CLEAN_STATE]: cleanState,
});

export default AdebifyProductAnalysisReducer;
